import { Box, Button, Dialog, DialogActions, DialogContentText, DialogTitle } from "@mui/material";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import "./translations";

export type UserFeatureNotAvailableDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const UserFeatureNotAvailableDialog = ({ onClose, open }: UserFeatureNotAvailableDialogProps): JSX.Element => {
  const { t } = useTranslation("UserFeatureNotAvailableDialog");
  const { t: tCommon } = useTranslation();
  return (
    <Dialog open={open} fullWidth maxWidth="xs" scroll="paper" disableRestoreFocus onClose={onClose}>
      <DialogTitle
        sx={(theme) => ({
          display: "flex",
          alignItems: "center",
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          p: "15.5px 20px ",
        })}
      >
        {t("title")}
      </DialogTitle>
      <Box
        sx={{
          textAlign: "center",
          p: "24px 20px",
          pt: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <DialogContentText>{t("text")}</DialogContentText>
      </Box>
      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Button variant="contained" color="primary" onClick={onClose}>
          {tCommon("buttons.ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
